import Pagination from '../../../../components/Pagination';
import usePagination from '../../../../hooks/usePagination';
import useUserOpenOrders from '../../../../hooks/web3/trade/useUserOpenOrders';
import ExchangeListsErrowRow from '../ExchangeListsErrorRow';
import ExchangeListsStatus from '../ExchangeListsStatus';
import OrderRow from './OrderRow';

const headers = [
    'Type',
    'Action',
    'Size',
    'Collateral',
    'Limit Price',
    'Liq. Price',
    'Deadline',
    '',
];

type OrderProps = {
    rowPerPage: number;
};

const Orders: React.FC<OrderProps> = ({ rowPerPage }) => {
    const { userOrders, isLoading, error } = useUserOpenOrders();
    const pagination = usePagination(rowPerPage, userOrders?.length || 0);

    return (
        <>
            <div className='exchange-list-content orders'>
                <ExchangeListsStatus isLoading={isLoading} error={error} message='orders'>
                    <div className='row header'>
                        {headers.map((header, index) => (
                            <div key={index}>{header}</div>
                        ))}
                    </div>
                    {userOrders && userOrders.length ? (
                        pagination
                            .paginateData(userOrders)
                            .map((order, index) => <OrderRow order={order} key={index} />)
                    ) : (
                        <ExchangeListsErrowRow message='You have no open orders' />
                    )}
                </ExchangeListsStatus>
            </div>
            {userOrders && userOrders.length > rowPerPage ? (
                <Pagination pagination={pagination} />
            ) : null}
        </>
    );
};

export default Orders;
